// extracted by css-extract-rspack-plugin
export default {"notes":"BaseForm__notes--WSURA","icon":"BaseForm__icon--rV_aa","text":"BaseForm__text--b_9Eq","bottomButtonsArea":"BaseForm__bottomButtonsArea--vmpEh"};